export default {"src":"/_next/static/media/mastercard.00c71c68.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};